import service from '../service.js'

export default{

    getLookUp(){
        return service.get('lookup')
    },
}